module.exports = __webpack_public_path__ + "static/media/NO_LACTOSE.90605697.svg";